import React from 'react';
import './App.css';
import CustomNavbar from './components/CustomNavBar'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import tnDefault from './Images/TrueNorth_default.png';
import tnSettings from './Images/TrueNorth_Settings.png';
import tnEditvars from './Images/TrueNorth_editvars.png';
import tnSelectvars from './Images/TrueNorth_selectvars.png';
import tnDefault_thumb from './Images/TrueNorth_default_thumb.png';
import tnSettings_thumb from './Images/TrueNorth_Settings_thumb.png';
import tnEditvars_thumb from './Images/TrueNorth_editvars_thumb.png';
import tnSelectvars_thumb from './Images/TrueNorth_selectvars_thumb.png';
import ImageGallery from 'react-image-gallery';
import logo from './Images/TrueNorth_server_2.png';
import CustomBtn from './components/CustomButton'
import  { FirebaseContext } from "./components/Firebase";
import { Route, Link, BrowserRouter as Router } from 'react-router-dom';
import "react-image-gallery/styles/css/image-gallery.css";
import { textAlign } from '@material-ui/system';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

//function App() {

class TrueNorthServer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    }

  }


componentDidMount(){
  this.handleClickOpen();
}

handleClickOpen = () => {
  this.setState({open:true});
};

handleClose = () => {
  this.setState({open:false});
};

render() {

  const boxStyle = { 
    width: 'fit-content', 
    background:'rgba(248, 248, 248, 0.6)', 
    borderRadius:'5px', 
    padding:'15px', 
    margin: '5px',
    minHeight: '500px',
    minWidth: '400px',
    boxShadow:'0 8px 12px 0 rgba(0, 0, 0, 0.24), 0 6px 20px 0 rgba(0, 0, 0, 0.18)'
  };

  const images = [
    {
      original: tnDefault,
      thumbnail: tnDefault_thumb,
    },
    {
      original: tnEditvars,
      thumbnail: tnEditvars_thumb
    },
    {
      original: tnSelectvars,
      thumbnail: tnSelectvars_thumb
    },
    {
      original: tnSettings,
      thumbnail: tnSettings_thumb
    }
  ]

  return (
    <div style={{height:'100%'}}>
      <div style={{minHeight:'92vh'}}>
      <CustomNavbar logo={true}></CustomNavbar>

      <Grid container spacing={0}>
        <Grid xs={12} md={6} style={{ paddingBottom:'45px'}}>
             <ImageGallery items={images} showFullscreenButton={false} showPlayButton={false} showNav={false} />
        </Grid>
        <Grid xs={12} md={6}>
            <Grid container direction="column" justify={'center'} alignItems={'center'} style={{marginLeft:'-10px' ,paddingTop:'30px'}}>
            <img src={logo} style={{maxWidth: '50%', marginBottom:'20px'}}/>
            <Typography variant="subtitle1" style={{marginTop:'5px',paddingBottom:'5px', color:'black', maxWidth:"70%", textAlign:'center'}}>
                   - Seamlessly connects your yachts instruments to connected Garmin watches via a udp broadcast.
            </Typography>  
            <Typography variant="subtitle1" style={{marginTop:'5px',paddingBottom:'5px', color:'black', maxWidth:"70%", textAlign:'center'}}>
                   - Supports Expedition and iDataNet UDP messages (Custom UDP messages to be added soon).
            </Typography> 
            <Typography variant="subtitle1" style={{marginTop:'5px',paddingBottom:'5px', color:'black', maxWidth:"70%", textAlign:'center'}}>
                   - Create profiles with the ability to Add and Edit available variables.
            </Typography> 
            <Typography variant="subtitle1" style={{marginTop:'5px',paddingBottom:'5px', color:'black', maxWidth:"70%", textAlign:'center'}}>
                   - Free to download with a 14 day trial after which there is a once off activation fee per license with the TrueNorth Garmin app free to download.  
            </Typography> 
            <Grid container direction="row" justify={'center'} alignItems={'flex-end'} style={{paddingTop:'25px'}}>
                <Link to="/Download" style={{textDecoration: 'none', margin:'-1% 0px 30px 0px'}}><CustomBtn click={null} name={'Download'}></CustomBtn></Link> 
                <Link to="/Activate" style={{textDecoration: 'none', margin:'-1% 0px 30px 0px'}}><CustomBtn click={null} name={'Buy Now'}></CustomBtn></Link>
            </Grid> 
                        
            </Grid>
        </Grid>
      </Grid>
      </div>
 
      <div style={{minHeight:'8vh', boxShadow:'0 0px 12px 0 rgba(0, 0, 0, 0.4), 0 0px 20px 0 rgba(0, 0, 0, 0.4)', backgroundColor:'#313131'}}>
      <Grid container direction="row" justify={'center'} alignItems={'center'} style={{height:'8vh'}}>
      <Typography variant="body2" style={{color:'white', textAlign: 'center'}}>
                  Contact us at truenorthsailingsoftware@gmail.com | +27-84-600-6091
    </Typography>
      </Grid>
      </div> 

      <Dialog
        open={this.state.open}
        onClose={this.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Please note."}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            From Garmin Connect App v4.20 the TrueNorth Server will no longer be able to communicate with your smartphone and therefore 
            your Garmin watch. We are busy working on different methods of communication but in the meantime if you will be required to 
            use Garmin Connect v4.19 or before. Thank you for your understanding.
            Please email truenorthsailingsoftware@gmail.com for any queries.  
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>


    </div>
    );
  }
}

export default TrueNorthServer;
